import type { DefaultListItemOption } from "./types";

export enum ModelPortfolioTypeOptions {
  FARTHER_LIST = "fartherList",
  FARTHER_MODEL_MARKET_PLACE = "fartherModelMarketPlace",
  FARTHER_FAMILY_BY_ID = "fartherFamilyById",
  PORTFOLIO_PLAN_BY_ID = "portfolioPlanById",
  SHARED_BY_ADVISOR = "sharedByAdvisor",
  CUSTOM_PORTFOLIOS = "customPortfolios",
}

export const defaultModelPortFolioList: DefaultListItemOption[] = [
  {
    title: "Farther",
    subTitle: "Use one of Farther’s Model Portfolios...",
    id: null,
    type: ModelPortfolioTypeOptions.FARTHER_LIST,
  },

  {
    title: "Farther Model Market Place",
    subTitle: "Use one of our model market place portfolios...",
    id: null,
    type: ModelPortfolioTypeOptions.FARTHER_MODEL_MARKET_PLACE,
  },
  {
    title: "Shared by Your Advisor",
    subTitle: "Use a custom model created by your advisor...",
    id: null,
    type: ModelPortfolioTypeOptions.SHARED_BY_ADVISOR,
  },
  {
    title: "Create a Custom Model Portfolio",
    subTitle: "Use a custom model portfolio...",
    id: null,
    type: ModelPortfolioTypeOptions.CUSTOM_PORTFOLIOS,
  },
] as const;
